
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CouponUser {
  id: string;
  user_id: string;
  applied_at: string;
  times_used: number;
  profiles: {
    id: string;
    email: string;
    first_name: string | null;
    last_name: string | null;
  } | null;
}

export const useCouponUsers = (couponId?: string) => {
  return useQuery({
    queryKey: ['coupon-users', couponId],
    queryFn: async () => {
      if (!couponId) return [];

      const { data, error } = await supabase
        .from('user_coupons')
        .select(`
          id,
          user_id,
          applied_at,
          times_used,
          profiles:user_id (
            id,
            email,
            first_name,
            last_name
          )
        `)
        .eq('coupon_id', couponId)
        .eq('is_active', true)
        .order('applied_at', { ascending: false });

      if (error) {
        console.error('Error fetching coupon users:', error);
        throw error;
      }

      return data as CouponUser[];
    },
    enabled: !!couponId,
    refetchOnWindowFocus: false,
    staleTime: 30000, // 30 seconds
  });
};
